import a from "./highrise661.mjs";
import i from "./highrise1329.mjs";
import n from "./highrise1533.mjs";
var e = Object.prototype, p = e.hasOwnProperty;
function v(r) {
  if (!a(r))
    return n(r);
  var s = i(r), o = [];
  for (var t in r)
    t == "constructor" && (s || !p.call(r, t)) || o.push(t);
  return o;
}
export {
  v as default
};
